import { api } from "@/lib/axios";

type Status = {
    type: string,
    name: string,
    _id: string;
    order: number;
}

const get = (): Promise<Status[]> =>
    api.get("/status").then((r) => r.data);

export default get;
